/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { date } from 'xrk-tools';
import { industryEnterpriseList } from '@/api/ajax';
export default [
  {
    width: 180,
    tip: '请输入文件名称',
    label: '文件名称',
    key: 'fileName',
    id: 'fileName',
    slot: 'input'
  },
  {
    width: 180,
    tip: '请输入操作者',
    label: '操作者',
    key: 'operatorName',
    id: 'operatorName',
    slot: 'input'
  },
  {
    width: 180,
    label: '基础信息',
    tip: '请选择基础信息配置显示',
    key: 'baseInfoMixValue',
    id: 'baseInfoMixValue',
    slot: 'ajaxSelect',
    clearable: true,
    ajax: async () => {
      return {
        data: {
          data: [
            {
              id: 7,
              enterpriseName: '项目执行方/手机号/任务提交时间'
            },
            {
              id: 6,
              enterpriseName: '项目执行方/手机号'
            },
            {
              id: 5,
              enterpriseName: '项目执行方/任务提交时间'
            },
            {
              id: 3,
              enterpriseName: '手机号/任务提交时间'
            },
            {
              id: 4,
              enterpriseName: '项目执行方'
            },
            {
              id: 2,
              enterpriseName: '手机号'
            },
            {
              id: 1,
              enterpriseName: '任务提交时间'
            },
            {
              id: -1,
              enterpriseName: '未配置'
            }
          ]
        }
      };
    },
    prop: {
      label: 'enterpriseName',
      code: 'id'
    }
  },
  {
    width: 180,
    id: 'monthrange',
    tip: '请选择下载时间',
    label: '下载时间',
    required: false,
    slot: 'daterange',
    val: [
      date.dateFormat(new Date().getTime() - 1000 * 60 * 60 * 24 * 30, 'Y-M-D'),
      date.dateFormat(new Date(), 'Y-M-D')
    ],
    format: 'yyyy-MM-dd',
    rangeValue: [],
    key: ['startDate', 'endDate']
  },
  {
    width: 180,
    label: '工业',
    tip: '请选择工业',
    key: 'industryEnterpriseId',
    id: 'industryEnterpriseId',
    slot: 'ajaxSelect',
    clearable: true,
    ajax: industryEnterpriseList,
    prop: {
      label: 'enterpriseName',
      code: 'id'
    },
    ajaxQuery: 'industryEnterpriseName'
  }
];
